import qs from 'query-string'
import apiV2 from '.'

export const settingsApi = apiV2.injectEndpoints({
  endpoints: builder => ({
    getMySettings: builder.query({
      query: ({ domainId, eventId, languageId, typoId }) => `/settings/me?${qs.stringify({ domainId, eventId, languageId, typoId })}`,
      transformResponse: response => response.data.settings,
      providesTags: ['SETTINGS'],
    }),
  }),
})

export const { useGetMySettingsQuery, useLazyGetMySettingsQuery } = settingsApi
